module.exports = __webpack_public_path__ + "static/img/ios.8cd7c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ios.png
// module id = djZz
// module chunks = 0